export default {
  main: { back: "#755d5c", front: "#333333" },

  pink_1: { back: "#a75e5e", front: "#463838" },
  pink_2: { back: "#8e6c8e", front: "#eee" },

  gray_1: { back: "#393432", front: "#eee" },
  gray_2: { back: "#636363", front: "#333333" },
  gray_3: { back: "#2d2d2d", front: "#eee" },
  gray_4: { back: "#47464f", front: "#999" }, //菜单背景色等
  gray_5: { back: "#4f4f5a", front: "#eee" },
  gray_6: { back: "#333333", front: "#333333" },
  gray_7: { back: "#999", front: "#999" },
  gray_8: { back: "#eee", front: "#eee" },
  gray_9: { back: "#111", front: "#111" },
  gray_10: { back: "#555", front: "#555" },
  gray_11: { back: "#333", front: "#333" },

  gray_12: { back: "#393432", front: "#eee" },//导航栏背景

  brown_1: { back: "#332f2c", front: "#999" },
  brown_2: { back: "#5e5653", front: "#eee" },
  brown_3: { back: "#47413c", front: "#eee" },
  brown_4: { back: "#393431", front: "#eee" },

  brown_5: { back: "#3a3535", front: "#999" },

  purple_1: { back: "#6c6379", front: "#333333" },
  purple_2: { back: "#6c607a", front: "#111111" },

  yellow_1: { back: "#7c5d01", front: "#111111" },
  yellow_2: { back: "#7b5d00", front: "#111111" },

  blue_1: { back: "#34343d", front: "#849aba" },
  blue_2: { back: "#374e79", front: "#eee" },
  blue_3: { back: "#34343d", front: "#849aba" }, //思考中背景

  green_1: { back: "#50815b", front: "#113700" },

  terminal_back: "#2d2d2d",
  terminal_front: "#eee",

  工具组成功背景: "#343d38",
  工具组失败背景: "#5c2f2f",
  工具组成功边框: "#50815b",
  工具组失败边框: "#ff6b6b",
  工具组文字颜色: "#999",

  确认框背景: "#2b292aee",
  确认框文字: "#eeeeee55",
  确认框标题: "#eee",
  确认框标题边框: "#97598f",
  确认框内容背景: "#47464f66",
  确认框输入背景: "rgba(0,0,0,0.2)",
  确认框输入边框: "rgba(255,255,255,0.1)",
  确认框输入文字: "#ccc",
  确认框按钮执行背景: "#97598f",
  确认框按钮执行文字: "#463838",
  确认框按钮拒绝背景: "#47464f",
  确认框按钮拒绝文字: "#eee",

}

